import { ChevronRight, Home } from 'lucide-react';
import { Link, useLocation } from 'react-router-dom';
import { TUTTI_V2_NAVIGATION } from '@/navigation/tuttiV2';
import { brandStore } from '@/stores';

const routeMap: Record<string, string> = {
  'test-management': '测试管理',
  brands: 'Brand 管理',
  'brand-selection': '选择 Brand',
  'admin-tokens': '管理密钥',
  'acquisition-attributions': '渠道归因',
  'room-capacity': '房间配额管理',
  'alert-attributions': '告警归因',
  'http-failures': '归因详情',
  'http-exceptions': '接口异常查询',
  applications: '应用管理',
  connectors: '连接器管理',
  skills: 'Skill 市场',
  'beta-management': '内测管理',
  'landing-waitlist': '邮箱邀请码名单',
  whitelist: '白名单管理',
  'user-configs': '用户配置管理',
  'room-debug-logs': 'Room 日志',
  'session-logs': 'Session 日志',
  commerce: '商业化管理',
  orders: '订单管理',
  credits: '积分管理',
  'cost-dashboard': '成本看板',
  [TUTTI_V2_NAVIGATION.routes.root]: TUTTI_V2_NAVIGATION.title,
  'agent-packages': 'Agent 包审核',
  computers: 'Tutti Computer',
  'product-updates': '更新消息',
  'computer-release-notes': 'Computer 发布信息',
  'host-artifact-upgrade': 'Computer Production 强制升级',
  tasks: '任务',
  workers: 'Worker Pool',
  executions: '执行详情',
};

export function Breadcrumb() {
  const location = useLocation();
  const pathnames = location.pathname.split('/').filter((x) => x);

  return (
    <nav className="flex items-center space-x-2 text-sm text-muted-foreground">
      <Link
        to="/"
        className="flex items-center hover:text-foreground transition-colors rounded-md p-1 hover:bg-bg-hover"
      >
        <Home className="h-4 w-4" />
      </Link>
      {pathnames.map((value, index) => {
        const to = `/${pathnames.slice(0, index + 1).join('/')}`;
        const linkTo =
          pathnames[0] === 'tasks' &&
          (value === 'workers' || value === 'executions')
            ? '/tasks'
            : to;
        const isLast = index === pathnames.length - 1;
        const isBrandSegment = index === 1 && pathnames[0] === 'brands';
        const isDesktopUpdatesSegment = value === 'desktop-updates';
        const isOpaqueTaskIdentifier =
          (pathnames[index - 1] === 'workers' ||
            pathnames[index - 1] === 'executions') &&
          value.length > 24;
        const label = isBrandSegment
          ? brandStore.getBrandById(value)?.name || value
          : isDesktopUpdatesSegment
            ? '协作版版本更新'
            : isOpaqueTaskIdentifier
              ? value.slice(0, 12) + '…'
              : routeMap[value] || value;

        return (
          <div key={to} className="flex items-center space-x-2">
            <ChevronRight className="h-4 w-4 text-muted-strong" />
            {isLast ? (
              <span className="text-text-strong font-semibold">{label}</span>
            ) : (
              <Link
                to={linkTo}
                className="hover:text-foreground transition-colors rounded-md px-1 py-0.5 hover:bg-bg-hover"
              >
                {label}
              </Link>
            )}
          </div>
        );
      })}
    </nav>
  );
}
